<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :width="width"
       v-if='dialogVisible'
      :visible.sync="dialogVisible"
      :fullscreen="fullscreen"
      :close-on-click-modal="closeOnClickModal"
      :before-close="handleBeforeClose"
      :destroy-on-close="destroyOnClose"
      @open="handlerOpen"
       :show-close="showClose" 
       :modal-append-to-body='isAppendToBody'
    >
      <slot></slot>
      <template #footer v-if="footerSlot">
        <span class="dialog-footer">
          <slot name="footer"> </slot>
        </span>
      </template>
      <template v-else-if="!footerSlot" #footer>
        <span class="dialog-footer">
          <el-button v-if="!closeCancel" @click="handleCancel">关闭</el-button>
          <el-button v-if="!closeSubmit" type="primary" @click="handleSubmit">{{
            dialogSubmitBtnText
          }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "lr-dialog",
  props: {
    dialogTitle: {
      type: String,
      default: "提示",
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    footerSlot: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "70%",
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    dialogSubmitBtnText: {
      type: String,
      default: "确定",
    },
    destroyOnClose: { type: Boolean, default: false },
    closeCancel:{
      type: Boolean,
      default: false,
    },
    closeSubmit:{
      type: Boolean,
      default: false,
    }, 
     showClose:  {
      type: Boolean,
      default: true,
    }, 
    
     isAppendToBody:  {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      //dialogVisible:false,
    };
  },
  watch: {
    dialogVisible: {
      handler: function (n, o) {
        if(n){
          this.handlerOpen()
        }
        //this.$emit('update:dialogVisible', false); // 直接修改父组件的属性
      },
      immediate: true,
    },
  },
  methods: {
    handleSubmit() {
      //this.$emit('update:dialogVisible', false);
      this.$emit("diaLogSubmit");
    },
    handleCancel() {
      this.$emit('cancel')
      this.$emit("update:dialogVisible", false);
    },
    handleBeforeClose(done) {
      this.$emit('beforeClose')
      this.$emit('cancel')
      this.$emit("update:dialogVisible", false);
      
    },
    handlerOpen(){this.$emit("dialogOpen");},
  },
};
</script>
<style scoped  lang="scss">
>>> .el-dialog__body{
  padding:0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/LrDialog/index.vue